const initialState = {};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
    case "SET_PERFORMANCE_DATA":
      return { ...state, performance: action.performance };

    default:
      return state;
  }
};

export default reducer;
